import React, { useEffect, useState } from 'react';

const isDispLog: boolean = false;

type Props = {
  label: string;
  value?: boolean;
  labelPosition?: number;
  labelStyle?: string;
  onChangeEvent: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ItemCheckBox: React.FC<Props> = (props) => {
  return (
    <table>
      <tbody>
        <tr>
          {props.labelPosition === 1 && <td className={props.labelStyle ?? ''}> {props.label}</td>}
          <td>
            <input type="checkbox" checked={props.value} onChange={(e) => props.onChangeEvent(e)} />
          </td>
          {props.labelPosition === 2 && <td className={props.labelStyle ?? ''}> {props.label}</td>}
        </tr>
      </tbody>
    </table>
  );
};
export default ItemCheckBox;
